/* North Borders — vanilla interactions for standalone export */
(function () {
  "use strict";

  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-nb-page-root]'));
  if (!roots.length) return;

  roots.forEach(function (pageRoot) {
    var $$ = function (sel, root) { return Array.prototype.slice.call((root || pageRoot).querySelectorAll(sel)); };

  // -------- Packs filter tabs
  (function () {
    var section = pageRoot.querySelector('[data-nb-packs]');
    if (!section) return;
    var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-nb-pack-filter]'));
    var cards   = Array.prototype.slice.call(section.querySelectorAll('[data-nb-pack-cat]'));
    if (!buttons.length || !cards.length) return;
    var grid = section.querySelector('.nb-product-grid');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cat = btn.getAttribute('data-nb-pack-filter');
        buttons.forEach(function (b) {
          var active = b === btn;
          b.classList.toggle('nb-filter--active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        cards.forEach(function (c) {
          c.classList.toggle('nb-pack-hidden', cat !== 'all' && c.getAttribute('data-nb-pack-cat') !== cat);
        });
        if (grid) grid.scrollLeft = 0;
      });
    });
    cards.sort(function (a, b) {
      return parseInt(a.getAttribute('data-nb-price'), 10) - parseInt(b.getAttribute('data-nb-price'), 10);
    });
    cards.forEach(function (c) { grid.appendChild(c); });
    grid.scrollLeft = 0;

    // Drag-to-scroll for hover-capable pointers (desktop narrow window).
    // Touch scrolling is handled natively; skip for coarse pointers.
    if (grid && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var isDown = false, startX = 0, startScroll = 0, moved = 0, didDrag = false, capturedId = -1;
      grid.addEventListener('pointerdown', function (e) {
        if (e.button !== 0) return;
        isDown = true; moved = 0; didDrag = false;
        startX = e.clientX;
        startScroll = grid.scrollLeft;
        // Do NOT setPointerCapture here — it retargets the subsequent click
        // to the grid element, breaking anchor navigation on plain clicks.
      });
      grid.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        moved = Math.max(moved, Math.abs(dx));
        if (!didDrag && moved > 4) {
          didDrag = true;
          grid.classList.add('is-dragging');
          try { grid.setPointerCapture(e.pointerId); capturedId = e.pointerId; } catch (err) {}
        }
        if (didDrag) grid.scrollLeft = startScroll - dx;
      });
      function endDrag(e) {
        if (!isDown) return;
        isDown = false;
        if (capturedId !== -1) {
          try { grid.releasePointerCapture(capturedId); } catch (err) {}
          capturedId = -1;
        }
        // Defer class removal so click on the card is still suppressed if we dragged.
        setTimeout(function () { grid.classList.remove('is-dragging'); }, 0);
      }
      grid.addEventListener('pointerup', endDrag);
      grid.addEventListener('pointercancel', endDrag);
      // Swallow click only if a real drag occurred (prevents accidental card-link navigation after a drag).
      grid.addEventListener('click', function (e) {
        if (didDrag) { e.preventDefault(); e.stopPropagation(); didDrag = false; }
      }, true);
    }
  }());

  // -------- Countdown --------
  // The section already rendered the correct digits server-side from the same
  // data-nb-draw-closes-at value, so this only keeps them moving. There is no
  // fallback target: an empty or unparseable attribute means no draw is set,
  // and the zeros Liquid rendered are left alone rather than being replaced by
  // a countdown to an invented date.
  var targetIso = pageRoot.getAttribute("data-nb-draw-closes-at");
  var TARGET = targetIso ? Date.parse(targetIso) : NaN;
  function pad(n) { return String(n).padStart(2, "0"); }
  function tickCountdown() {
    var diff = Math.max(0, TARGET - Date.now());
    var vals = [
      Math.floor(diff / 86400000),
      Math.floor((diff / 3600000) % 24),
      Math.floor((diff / 60000) % 60),
      Math.floor((diff / 1000) % 60)
    ];
    $$('[data-nb-countdown]').forEach(function (grid) {
      var nums = $$('[data-nb-countdown-value]', grid);
      nums.forEach(function (el, i) { if (vals[i] != null) el.textContent = pad(vals[i]); });
    });
  }
  if (Number.isFinite(TARGET)) {
    tickCountdown();
    setInterval(tickCountdown, 1000);
  }

  // -------- Monthly / Yearly toggle + tier price updates --------
  $$(".nb-section--tiers").forEach(function (section) {
    var yearly = false;

    function applyYearly() {
      $$("[data-nb-billing-toggle]", section).forEach(function (btn) {
        var isYearlyBtn = /Yearly/.test(btn.textContent);
        var active = isYearlyBtn === yearly;
        btn.classList.toggle("nb-toggle__button--active", active);
        btn.setAttribute("aria-pressed", active ? "true" : "false");
      });
      $$("[data-nb-tier-price]", section).forEach(function (el) {
        if (!el.dataset.basePrice) {
          el.dataset.basePrice = (el.textContent || "").replace(/[^0-9.]/g, "");
        }
        var base = parseFloat(el.dataset.basePrice) || 0;
        el.textContent = "$" + (yearly ? (base * 10).toFixed(2) : base.toFixed(2));
      });
      $$("[data-nb-tier-period]", section).forEach(function (el) {
        el.textContent = yearly ? "USD / yr" : "USD / mo";
      });
    }

    $$("[data-nb-billing-toggle]", section).forEach(function (btn) {
      btn.addEventListener("click", function () {
        yearly = /Yearly/.test(btn.textContent);
        applyYearly();
      });
    });
    applyYearly();
  });

  // -------- Proxy visible November membership toggles to the price-table snippet --------
  $$(".nb-section--tiers").forEach(function (section) {
    var proxyToggle = section.querySelector("[data-nb-price-proxy-toggle]");
    var snippetToggle = section.querySelector(".pricing-wrapper .pricing-toggle");
    if (!proxyToggle || !snippetToggle) return;

    var proxyButtons = $$("[data-nb-price-proxy-plan]", proxyToggle);

    function getActivePlan() {
      var activeReal = snippetToggle.querySelector(".toggle-option.active");
      if (activeReal && activeReal.getAttribute("data-plan")) {
        return activeReal.getAttribute("data-plan");
      }
      return snippetToggle.classList.contains("monthly") ? "monthly" : "yearly";
    }

    var oldPriceLine = section.querySelector("[data-nb-old-price-line]");

    function syncProxy() {
      var activePlan = getActivePlan();
      if (oldPriceLine) oldPriceLine.hidden = activePlan === "yearly";
      proxyButtons.forEach(function (btn) {
        var active = btn.getAttribute("data-nb-price-proxy-plan") === activePlan;
        btn.classList.toggle("active", active);
        btn.classList.toggle("nb-toggle__button--active", active);
        btn.setAttribute("aria-pressed", active ? "true" : "false");
      });
    }

    proxyButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var plan = btn.getAttribute("data-nb-price-proxy-plan");
        var realButton = snippetToggle.querySelector('.toggle-option[data-plan="' + plan + '"]');
        if (realButton) realButton.click();
        window.setTimeout(syncProxy, 0);
      });
    });

    syncProxy();
    document.addEventListener("DOMContentLoaded", function () {
      window.setTimeout(syncProxy, 0);
    }, { once: true });
  });

  // -------- One-off vs membership maths chart --------
  (function () {
    var chartSection = pageRoot.querySelector("#nb-chart");
    if (!chartSection) return;

    var ONE_OFF = 75;
    var tier = "two";
    var tiers = {
      one: { start: 10, rate: 2 },
      two: { start: 30, rate: 10 }
    };

    var slider = chartSection.querySelector("[data-nb-math-month]");
    var monthValue = chartSection.querySelector("[data-nb-math-month-value]");
    var currentEl = chartSection.querySelector("[data-nb-math-current]");
    var totalEl = chartSection.querySelector("[data-nb-math-total]");
    var oneOffEl = chartSection.querySelector("[data-nb-math-oneoff]");
    var multipleEl = chartSection.querySelector("[data-nb-math-multiple]");
    var chartSvg = chartSection.querySelector("[data-nb-math-chart]");
    var totalLabel = chartSection.querySelectorAll(".nb-stat-card__label")[1];

    function entriesAt(config, month) {
      return config.start + config.rate * (month - 1);
    }

    function totalBy(config, month) {
      return Math.round((month / 2) * (2 * config.start + (month - 1) * config.rate));
    }

    function drawChart(month, config) {
      if (!chartSvg) return;
      var width = 720;
      var height = 230;
      var left = 12;
      var right = 12;
      var top = 30;
      var bottom = 30;
      var plotH = height - top - bottom;
      var plotW = width - left - right;
      var max = Math.max(ONE_OFF, entriesAt(config, 12));
      var slot = plotW / 12;
      var barW = slot * 0.88;
      var lineY = top + plotH - (ONE_OFF / max) * plotH;
      var oneOffLabelY = Math.max(12, lineY - 8);
      var html =
        '<line x1="' + left + '" x2="' + (width - right) + '" y1="' + lineY + '" y2="' + lineY + '" stroke="#5C626B" stroke-dasharray="4 4" stroke-width="1"></line>' +
        '<text class="nb-chart-label" x="' + left + '" y="' + oneOffLabelY + '" text-anchor="start" fill="#AEB5BF" font-size="9" font-family="JetBrains Mono">ONE-OFF · ' + ONE_OFF + "</text>";

      for (var i = 1; i <= 12; i += 1) {
        var val = entriesAt(config, i);
        var barH = Math.max(2, (val / max) * plotH);
        var x = left + (i - 1) * slot + (slot - barW) / 2;
        var y = top + plotH - barH;
        var active = i === month;
        html +=
          '<g>' +
          '<rect x="' + x + '" y="' + y + '" width="' + barW + '" height="' + barH + '" fill="#FFB020" opacity="' + (0.45 + i / 24).toFixed(3) + '" rx="2"></rect>' +
          (active ? '<rect x="' + (x - 1) + '" y="' + (y - 1) + '" width="' + (barW + 2) + '" height="' + (barH + 2) + '" fill="none" stroke="#F4F5F7" stroke-width="1.2" rx="2"></rect><text x="' + (x + barW / 2) + '" y="' + (y - 6) + '" text-anchor="middle" fill="#F4F5F7" font-size="11" font-family="JetBrains Mono" font-weight="700">' + val + "</text>" : "") +
          '<text class="nb-chart-label" x="' + (x + barW / 2) + '" y="220" text-anchor="middle" fill="#868C96" font-size="9" font-family="JetBrains Mono">' + String(i).padStart(2, "0") + "</text>" +
          '<rect class="nb-chart-hit-area" data-nb-chart-month="' + i + '" x="' + (left + (i - 1) * slot) + '" y="' + top + '" width="' + slot + '" height="' + plotH + '" fill="transparent"></rect>' +
          "</g>";
      }
      chartSvg.innerHTML = html;
      $$("[data-nb-chart-month]", chartSvg).forEach(function (hit) {
        hit.addEventListener("click", function () {
          if (!slider) return;
          slider.value = hit.getAttribute("data-nb-chart-month");
          draw();
        });
      });
    }

    function draw() {
      var month = Math.max(1, Math.min(12, parseInt(slider && slider.value, 10) || 12));
      var config = tiers[tier] || tiers.two;
      var current = entriesAt(config, month);
      var total = totalBy(config, month);

      if (slider) slider.value = month;
      if (monthValue) monthValue.textContent = month;
      if (currentEl) currentEl.textContent = current.toLocaleString();
      if (totalEl) totalEl.textContent = total.toLocaleString();
      if (oneOffEl) oneOffEl.textContent = ONE_OFF.toLocaleString();
      if (multipleEl) multipleEl.textContent = (total / ONE_OFF).toFixed(1) + "× more";
      if (totalLabel) totalLabel.textContent = "Total by month " + month;
      drawChart(month, config);
    }

    $$("[data-nb-math-tier]", chartSection).forEach(function (btn) {
      btn.addEventListener("click", function () {
        tier = btn.getAttribute("data-nb-math-tier") || "two";
        $$("[data-nb-math-tier]", chartSection).forEach(function (other) {
          var active = other === btn;
          other.classList.toggle("nb-toggle__button--active", active);
          other.setAttribute("aria-pressed", active ? "true" : "false");
        });
        draw();
      });
    });

    if (slider) slider.addEventListener("input", draw);
    window.addEventListener("resize", draw, { passive: true });
    draw();
  })();


  // -------- Floating Enter Now button: show after hero leaves viewport --------
  (function () {
    var fab = pageRoot.querySelector("[data-nb-fab]");
    var hero = pageRoot.querySelector(".nb-hero");
    if (!fab || !hero || !("IntersectionObserver" in window)) {
      if (fab) fab.classList.add("is-visible");
      return;
    }
    var fabObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        fab.classList.toggle("is-visible", !entry.isIntersecting);
      });
    }, { threshold: 0 });
    fabObserver.observe(hero);
  })();

  // -------- Sticky Enter Now button -> join modal --------
  (function () {
    // The sticky bar, the hero CTA and the final CTA all open the same sheet.
    // Scoped to the document, not to pageRoot: there is one sheet on the page and
    // the final CTA is a separate nb-page-root, so a root-scoped lookup would miss
    // it. This block runs once, on whichever root reaches it first.
    var modal = document.querySelector("[data-nb-join-modal]");
    if (!modal || modal.getAttribute('data-nb-join-wired') === 'true') return;
    // Openers are marked by data-nb-join-open ONLY. data-nb-fab is not in this
    // list: it marks the sticky button's identity for the visibility observer,
    // and that button now renders data-nb-join-open only when its section
    // setting says "Open the join modal". In "Scroll to a section" mode it keeps
    // data-nb-fab and loses this one, so it stays visible but never opens the
    // sheet. Listing data-nb-fab here would make scroll mode do both.
    var openers = document.querySelectorAll("[data-nb-join-open]");
    if (!openers.length) return;
    modal.setAttribute('data-nb-join-wired', 'true');
    var lastFocused = null;

    // The offset the page was at when an opener was clicked, captured before any
    // listener on the opener itself can run.
    //
    // This has to be a capture-phase listener on the document. Whatever focuses
    // #nb-membership is bound to the same elements we are and was registered
    // first, so it has already scrolled the page by the time our click handler
    // runs. Reading pageYOffset inside openModal therefore read the position
    // AFTER the jump, which is why simply restoring it did nothing. Capture on an
    // ancestor runs before every listener on the target, jump included.
    var clickY = null;
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('[data-nb-join-open]')) clickY = window.pageYOffset;
    }, true);

    function openModal() {
      lastFocused = document.activeElement;
      var keepY = clickY === null ? window.pageYOffset : clickY;
      clickY = null;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('nb-join-modal-open');

      // Was "KNOWN, NOT FIXED: this focus call does not land". It does not land
      // because the sheet transitions `visibility` over 180ms (see the
      // stylesheet in snippets/nb-join-modal.liquid), so for those 180ms the
      // close button is still visibility:hidden and focus() on a hidden element
      // is a silent no-op. A rAF is far too early, which is why rAF "did not
      // help" and the cause looked like something else. Wait for the sheet to be
      // genuinely visible, then focus.
      //
      // Separately, and this is the part that was mistaken for the focus bug:
      // something outside this file focuses #nb-membership on this same click,
      // and focusing an element scrolls it into view, so the page slid to the
      // tiers behind the open sheet. Measured before this fix: open at y=6000,
      // land at y=2387, one millisecond after the click and before this function
      // is even reached. Put it back. The first pin below is synchronous, so the
      // page is already restored before the browser paints and there is no
      // flicker; the later ones catch anything that lands after us. The sheet is
      // position:fixed, so nothing the user can see moves either way.
      // Two things make the restore harder than one scrollTo.
      //
      // 1. The document sets scroll-behavior: smooth, so a plain
      //    scrollTo(0, keepY) ANIMATES back over ~half a second and the
      //    correction itself becomes the visible jump. Turn smooth off for the
      //    length of the pin window, so both the foreign scroll and ours are
      //    instant, then hand the setting back.
      // 2. The foreign scroll does not always start on the same tick as the
      //    click. Pinning once, or for two frames, misses the late ones. So pin
      //    on every frame for a short window instead.
      var root = document.documentElement;
      var prevBehavior = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      var pin = function () { if (window.pageYOffset !== keepY) window.scrollTo(0, keepY); };
      pin();
      var pinUntil = 400;
      var pinStart = null;
      var pinFrame = function (t) {
        if (pinStart === null) pinStart = t;
        pin();
        if (t - pinStart < pinUntil) {
          requestAnimationFrame(pinFrame);
        } else {
          root.style.scrollBehavior = prevBehavior;
        }
      };
      requestAnimationFrame(pinFrame);
      setTimeout(function () {
        pin();
        var closeBtn = modal.querySelector('.nb-join-modal__close');
        if (closeBtn && getComputedStyle(modal).visibility === 'visible') {
          closeBtn.focus({ preventScroll: true });
        }
      }, 220);
    }
    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('nb-join-modal-open');
      // preventScroll for the same reason as above: giving focus back should
      // hand the keyboard over, not move the page under the user.
      if (lastFocused && typeof lastFocused.focus === 'function') {
        try { lastFocused.focus({ preventScroll: true }); } catch (e) { lastFocused.focus(); }
      }
    }

    // The href stays in the markup as the no-JS fallback and we cancel it here.
    //
    // preventDefault alone is not the whole story. The browser default is
    // cancelled, but the theme's own anchor handling also focuses the target
    // section, and focusing an element scrolls it into view, so the page can
    // travel to #nb-membership behind the open sheet. That is what the
    // capture-phase clickY recorder above is for: it reads the offset before
    // any of that runs and openModal pins the page back to it. Fragment href
    // kept, jump handled.
    Array.prototype.forEach.call(openers, function (opener) {
      opener.addEventListener('click', function (e) {
        e.preventDefault();
        openModal();
      });
    });

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-nb-join-close]')) {
        e.preventDefault();
        closeModal();
        return;
      }
      // A tier row is a real checkout link. Let it navigate, just close behind it.
      if (e.target.closest('.nb-join-row')) closeModal();
    });

    // Anything that is not an opener element can still ask for the sheet by
    // firing this event. The prize cards use it: they are in the same root, but
    // going through the event keeps the open/close logic in one place.
    document.addEventListener('nb:join-open', openModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeModal();
    });
  }());

  // -------- Prize card "Full specs" disclosure toggle (S3, both breakpoints) --------
  (function () {
    var toggles = $$('.nb-prize-disclosure__toggle');
    if (!toggles.length) return;
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }());

  // -------- Prize tabs (mobile-only): swap between 1st / 2nd / 3rd panels --------
  (function () {
    var tabs = $$('[data-nb-prize-tab]');
    var panels = $$('[data-nb-prize-panel]');
    if (!tabs.length || !panels.length) return;
    function select(i) {
      tabs.forEach(function (t, j) {
        var active = i === j;
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.classList.toggle('nb-prize-tab--active', active);
        if (active) { t.removeAttribute('tabindex'); } else { t.setAttribute('tabindex', '-1'); }
      });
      panels.forEach(function (p, j) {
        if (i === j) { p.setAttribute('data-nb-prize-active', ''); }
        else { p.removeAttribute('data-nb-prize-active'); }
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        var next = -1;
        if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next < 0) return;
        e.preventDefault();
        select(next);
        tabs[next].focus();
      });
    });
  }());

  // -------- Membership tier cards: mobile disclosure (scoped to this page) --------
  (function () {
    var cards = $$('.nb-membership-price-table .nb-tier-card');
    if (!cards.length) return;
    cards.forEach(function (card) {
      if (card.querySelector('.nb-tier-toggle')) return;
      var body = card.querySelector('.nb-tier-card__body');
      var cta = card.querySelector('a[class*="join-tier"]');
      if (!body || !cta) return;
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'nb-tier-toggle';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = 'Show benefits';
      toggle.addEventListener('click', function () {
        var open = card.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.textContent = open ? 'Hide benefits' : 'Show benefits';
      });
      cta.parentNode.insertBefore(toggle, cta);
    });
  }());

  // -------- Smooth scroll for in-page anchor links --------
  $$('a[href^="#"]').forEach(function (a) {
    a.addEventListener("click", function (e) {
      // Modal openers keep their href only as a no-JS fallback. While the
      // sheet is on the page they must not also scroll the section into view.
      // Same reason as above for not matching data-nb-fab: a sticky button in
      // scroll mode is not an opener, and skipping it here would kill the only
      // thing it does.
      if (
        a.matches("[data-nb-join-open]") &&
        document.querySelector("[data-nb-join-modal]")
      ) {
        return;
      }
      var id = a.getAttribute("href").slice(1);
      if (!id) return;
      var el = pageRoot.querySelector("#" + id);
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });

  // -------- Hero video: click to toggle play/pause --------
  var heroReel = pageRoot.querySelector(".nb-hero-reel");
  var heroVideo = pageRoot.querySelector("[data-nb-hero-video]");
  var heroPlayButton = pageRoot.querySelector("[data-nb-hero-play]");

  if (heroPlayButton && heroVideo) {
    var heroPlayIconHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg>';
    var heroPauseIconHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect></svg>';

    var syncHeroButton = function () {
      if (heroVideo.paused) {
        heroPlayButton.innerHTML = heroPlayIconHTML;
        heroPlayButton.setAttribute("aria-label", "Play video");
        heroPlayButton.classList.remove("is-playing");
      } else {
        heroPlayButton.innerHTML = heroPauseIconHTML;
        heroPlayButton.setAttribute("aria-label", "Pause video");
        heroPlayButton.classList.add("is-playing");
      }
    };

    var isMobileViewport = function () {
      return window.matchMedia && window.matchMedia("(max-width: 47.9375rem)").matches;
    };

    var attachTapCatcher = function () {
      if (!heroReel) return;
      if (heroReel.querySelector(".nb-hero-reel__tap-catch")) return;
      var catcher = document.createElement("div");
      catcher.className = "nb-hero-reel__tap-catch";
      catcher.setAttribute("aria-hidden", "true");
      catcher.addEventListener("click", function (event) {
        event.stopPropagation();
        if (heroVideo.paused) startHeroPlayback();
        else heroVideo.pause();
      });
      heroReel.appendChild(catcher);
    };

    var enableNativeControls = function () {
      if (heroVideo.hasAttribute("controls")) return;
      heroVideo.setAttribute("controls", "");
      heroVideo.setAttribute("controlslist", "nodownload");
      if (heroReel) heroReel.classList.add("has-native-controls");
      attachTapCatcher();
    };

    var startHeroPlayback = function () {
      heroVideo.muted = false;
      heroVideo.volume = 1;
      heroVideo.play && heroVideo.play().catch(function () {});
    };

    var toggleHeroVideo = function () {
      if (!heroVideo.paused) {
        heroVideo.pause();
        return;
      }
      var shouldWaitForExpand =
        heroReel &&
        isMobileViewport() &&
        !heroReel.classList.contains("is-expanded") &&
        !heroReel.classList.contains("has-native-controls");

      if (!shouldWaitForExpand) {
        enableNativeControls();
        startHeroPlayback();
        return;
      }

      if (heroVideo.preload === "none") heroVideo.preload = "metadata";
      var handled = false;
      var finish = function () {
        if (handled) return;
        handled = true;
        heroReel.removeEventListener("transitionend", onEnd);
        enableNativeControls();
        startHeroPlayback();
      };
      var onEnd = function (e) {
        if (e && e.propertyName && e.propertyName !== "aspect-ratio") return;
        finish();
      };
      heroReel.addEventListener("transitionend", onEnd);
      setTimeout(finish, 500);
      heroReel.classList.add("is-expanded");
    };

    heroPlayButton.addEventListener("click", function (event) {
      event.stopPropagation();
      toggleHeroVideo();
    });
    if (heroReel) {
      heroReel.addEventListener("click", function (event) {
        if (heroVideo.hasAttribute("controls")) return;
        if (event.target === heroVideo) return;
        toggleHeroVideo();
      });
    }
    heroVideo.addEventListener("play", syncHeroButton);
    heroVideo.addEventListener("pause", syncHeroButton);
    heroVideo.addEventListener("ended", syncHeroButton);
  }

  // -------- Prize card -> join sheet (S2)
  (function () {
    // The prize cards used to open their own modal, which offered three routes:
    // a one-off pack, Tier One and Tier Two. Packs are off this page and the two
    // tier buttons carried yearly entry numbers, so the whole thing was stale.
    // The cards now open the same join sheet as every other CTA on the page.
    var section = pageRoot.querySelector('#nb-prizes');
    if (!section) return;

    section.addEventListener('click', function (e) {
      var card = e.target.closest('.nb-prize-card');
      if (!card || !section.contains(card)) return;
      // Tabs, the specs toggle and any real link inside the card keep their own
      // behaviour. A click that is only finishing a text selection is not a click.
      if (e.target.closest('button, a, [data-nb-prize-disclosure]')) return;
      var sel = window.getSelection && window.getSelection();
      if (sel && String(sel).length > 0) return;
      document.dispatchEvent(new CustomEvent('nb:join-open'));
    });
  }());

  (function initPacksHint() {
    if (!window.matchMedia('(max-width: 47.9375rem)').matches) return;
    var section = pageRoot.querySelector('.nb-packs--slider');
    if (!section) return;
    var rail = section.querySelector('.nb-product-grid');
    if (!rail || !rail.parentNode) return;

    var wrap = document.createElement('div');
    wrap.className = 'nb-packs__rail-wrap';
    rail.parentNode.insertBefore(wrap, rail);
    wrap.appendChild(rail);

    var hint = document.createElement('div');
    hint.className = 'nb-packs__hint';
    hint.setAttribute('aria-hidden', 'true');
    hint.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 6 9 12 15 18"></polyline></svg>';
    wrap.appendChild(hint);

    var swiped = false;
    var armScrollBase = 0;

    function play() {
      if (swiped) return;
      hint.classList.remove('is-playing');
      // force reflow so the animation restarts on re-entry
      void hint.offsetWidth;
      hint.classList.add('is-playing');
    }
    function stopForever() {
      if (swiped) return;
      swiped = true;
      hint.classList.remove('is-playing');
      if (hint.parentNode) hint.parentNode.removeChild(hint);
      rail.removeEventListener('scroll', onRailScroll);
      rail.removeEventListener('touchmove', stopForever);
    }
    function onRailScroll() {
      if (Math.abs(rail.scrollLeft - armScrollBase) > 8) stopForever();
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            armScrollBase = rail.scrollLeft;
            play();
          }
        });
      }, { threshold: 0.35 });
      io.observe(wrap);
    } else {
      play();
    }

    rail.addEventListener('scroll', onRailScroll, { passive: true });
    rail.addEventListener('touchmove', stopForever, { passive: true });
  }());

    // -------- Jump nav: show it once the hero is well behind you
    (function () {
      var nav = pageRoot.querySelector('[data-nb-jumpnav]');
      if (!nav) return;

      var ticking = false;

      // A screen and a half. Far enough that the nav never covers the hero,
      // close enough that it is there the moment you start reading.
      function threshold() {
        return Math.round(window.innerHeight * 1.5);
      }

      function update() {
        ticking = false;
        if (window.scrollY > threshold()) nav.setAttribute('data-visible', '');
        else nav.removeAttribute('data-visible');
      }

      window.addEventListener('scroll', function () {
        if (ticking) return;
        window.requestAnimationFrame(update);
        ticking = true;
      }, { passive: true });

      update();
    }());
  });
})();
